import { Box, Flex, Image } from "@chakra-ui/react";
import PropTypes from "prop-types";
import logo from "assets/img/auth/logo.svg";

function BusinessAuth(props: { children: JSX.Element | string }) {
  const { children } = props;

  return (
    <Flex
      minHeight="100vh"
      width="100vw"
      bgGradient="linear(to-b, #F7F7F9, #EBF0FB)"
      flexDirection="column"
      overflowY="auto"
      fontFamily="General Sans, Inter, sans-serif"
    >
      {/* Header with Logo */}
      <Flex
        w="100%"
        bg="white"
        py="20px"
        px={{ base: "20px", md: "40px" }}
        justifyContent="center"
        borderBottom="1px solid #E9E9E9"
      >
        <Box maxW="1200px" w="100%">
          <Flex alignItems="center" justifyContent="center">
            <Image src={logo} alt="Languex logo" height="32px" />
          </Flex>
        </Box>
      </Flex>

      {/* Main Content */}
      <Flex
        flex="1"
        w="100%"
        justifyContent="center"
        alignItems="flex-start"
        pt={{ base: "24px", md: "32px" }}
        pb={{ base: "40px", md: "60px" }}
        px={{ base: "20px", md: "40px" }}
      >
        <Box w="100%" maxW="1200px">
          {children}
        </Box>
      </Flex>
    </Flex>
  );
}

BusinessAuth.propTypes = {
  children: PropTypes.any,
};

export default BusinessAuth;
